/**
 * Preferences API
 *
 * Network-only functions for submitting preferences and getting recommendations.
 * NO Redux imports allowed in this file.
 *
 * Uses common API utilities which automatically add:
 * - Headers: X-Gommt-Mmt-Auth, X-Gommt-Uuid, X-Device-Id
 */
import * as v from 'valibot';
import {
  type OnboardingPreferences,
  type OnboardingRecommendations,
  OnboardingPreferencesSchema,
  PreferencesApiResponseSchema,
} from '@contracts';
import { ONBOARDING_ENDPOINTS } from '@/api/endpoints';
import { fetchApi, validateApiResponse, buildHeaders } from './apiUtils';

/**
 * Submit user preferences and get personalized recommendations
 *
 * Uses common API utilities with automatic:
 * - Headers: X-Gommt-Mmt-Auth, X-Gommt-Uuid, X-Device-Id
 */
export async function submitPreferences(
  preferences: OnboardingPreferences,
): Promise<OnboardingRecommendations> {
  const validatedPreferences = v.parse(OnboardingPreferencesSchema, preferences);

  const { data, response } = await fetchApi({
    url: ONBOARDING_ENDPOINTS.PREFERENCES,
    method: 'POST',
    headers: buildHeaders(),
    body: validatedPreferences,
  });

  const parsedResponse = v.parse(PreferencesApiResponseSchema, data);
  validateApiResponse(parsedResponse, response);

  return parsedResponse.questions ?? [];
}
